/**
 * @fileoverview GET handler for the "/engagement/api/segment_cohorts/:segment_cohort_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementApiSegmentCohortsId } from "./constants";
import type { SegmentCohortList } from "./types";

export const getSegmentCohort = reactQueryFetcherAdapter(
  engagementApiSegmentCohortsId,
  (signal: AbortSignal, segmentCohortId: string): Promise<SegmentCohortList> => {
    return fetch(`/engagement/api/segment_cohorts/${segmentCohortId}`, "GET", {}, { signal });
  }
);
